import * as React from "react";
import { $, merge } from "glamor";
import theme from "styles/theme";

const styles = merge(
    {
        padding: "30px 20px",
        backgroundColor: theme.palette.lighterGrey,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "20px 20px 0 20px",
    },
    $(" p", {
        color: theme.palette.grey,
        textAlign: "center",
        fontSize: "15px",
        lineheight: "1.5",
    })
);

interface IEmptyMessageProps {
    message: string;
}

export const EmptyMessage: React.FC<IEmptyMessageProps> = ({ message }) => (
    <div {...styles}>
        <p>{message}</p>
    </div>
);
